require('./referralsFormView.scss');

// @vendors
const React = require('react');
const PropTypes = require('prop-types');
const { connect } = require('react-redux');
const { withRouter } = require('react-router-dom');

// @commons
const { LoadingSection } = require('commonsComponents/loadingSection');
const { OKCover } = require('commonsComponents/OKCover');
const { OKHeaderSubPage } = require('commonsComponents/OKHeaderSubPage');
const { OKSectionBox } = require('commonsComponents/OKSectionBox');

// @components
const ReferralsFormWithEmail = require('components/referralsForm/referralsFormWithEmail/referralsFormWithEmail');
const ReferralsFormWithoutEmail = require('components/referralsForm/referralsFormWithoutEmail/referralsFormWithoutEmail');

// @actions
const sendReferralsActions = require('actions/sendReferrals');

// @helpers
const { formatText, getFinalTitle } = require('core/i18n').i18n;
const PersonalDataHelper = require('utilities/personalDataHelper');

class ReferralsFormView extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            openModalReferrals: false
        }

        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleToggleModalReferrals = this.handleToggleModalReferrals.bind(this);
    }

    componentWillMount() {
        if (!this.props.immReferrals.get('promotionsSuccess')) { // We need promotions loaded so we redirect to referrals
            this.props.history.push('/myprofile/referrals');
        }
    }

    componentDidMount() {
        const { match: { params: { code } }, setPromoCode } = this.props;
        setPromoCode(code);
    }

    componentWillUnmount() {
        this.props.reset();
    }

    handleToggleModalReferrals() {
        this.setState((previousState) => {
            return {
                openModalReferrals: !previousState.openModalReferrals
            }
        });
    }

    handleSubmit() {
        const { match: { params: { code } } } = this.props;
        this.props.sendEmailsReferrals(code);
    }

    render() {
        const {
            copyClipboardSuccess,
            immGlobalVariables,
            immProfile,
            immReferrals,
            immSendReferrals,
            match: { params: { code } },
            reset
        } = this.props;
        const mappingBreadcrumb = [{
            text: formatText('referrals-inviteFriend'),
            url: '/myprofile/referrals'
        }, {
            text: formatText('referrals-breadcrumbAddReferral'),
            url: ''
        }];

        let content;
        if (immProfile.get('isFetching')) { // It's happen with a hard refresh
            content = (
                <div className="col-xs-12">
                    <OKSectionBox>
                        <LoadingSection />
                    </OKSectionBox>
                </div>
            );
        } else {
            const email = PersonalDataHelper.getEmail(immProfile);
            const immPromotion = immReferrals.get('promotionsList').find(immPromotion => immPromotion.get('promotionCode') === code);

            if (!!email && immReferrals.get('promotionsSuccess')) {
                content = (
                    <ReferralsFormWithEmail
                        immSendReferrals={immSendReferrals}
                        email={email}
                        onSubmit={this.handleSubmit}
                        promotionTitle={immPromotion.get('title')}
                        handleReset={reset}
                    />
                );
            } else {
                content = (
                    <ReferralsFormWithoutEmail
                        immGlobalVariables={immGlobalVariables}
                        immSendReferrals={immSendReferrals}
                        isPreviewOpen={this.state.openModalReferrals}
                        onSubmit={this.handleSubmit}
                        onTogglePreview={this.handleToggleModalReferrals}
                        copyClipboardSuccess={copyClipboardSuccess}
                        handleReset={reset}
                        promotionCode={code}
                    />
                );
            }
        }

        return (
            <div>
                <div className="container-fluid">
                    <div className="row">
                        <OKCover
                            size="medium"
                            section="mgm"
                            customClass="col-xs-12"
                        >
                            <OKHeaderSubPage
                                breadcrumbConfig={mappingBreadcrumb}
                                finalTitle={getFinalTitle('referrals-inviteFriend')}
                            />
                        </OKCover>
                    </div>
                </div>
                <section className="referrals-form-view">
                    <div className="grid-view__body">
                        <div className="container-fluid">
                            <div className="row grid-view--content-position-negative">
                                {content}
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        );
    }
}

ReferralsFormView.propTypes = {
    copyClipboardSuccess: PropTypes.func.isRequired,
    history: PropTypes.object.isRequired,
    immGlobalVariables: PropTypes.object.isRequired,
    immSendReferrals: PropTypes.object.isRequired,
    immProfile: PropTypes.object.isRequired,
    immReferrals: PropTypes.object.isRequired,
    match: PropTypes.object.isRequired,
    reset: PropTypes.func.isRequired,
    sendEmailsReferrals: PropTypes.func.isRequired,
    setPromoCode: PropTypes.func.isRequired,
};

module.exports.constructor = ReferralsFormView;
module.exports.ReferralsFormView = connect(
    (state) => ({
        immGlobalVariables: state.globalVariables,
        immProfile: state.profile,
        immReferrals: state.referrals,
        immSendReferrals: state.sendReferrals
    }), {
    copyClipboardSuccess: sendReferralsActions.copyClipboardSuccess,
    reset: sendReferralsActions.reset,
    sendEmailsReferrals: sendReferralsActions.sendEmailsReferrals,
    setPromoCode: sendReferralsActions.setPromoCode
}
)(withRouter(ReferralsFormView));
